import { REDUCER_NAME as PARENT_REDUCER_NAME } from '../const'
import { REDUCER_NAME } from './const'

const NS = PARENT_REDUCER_NAME + '/' + REDUCER_NAME + '/'

export const CHANGE_TABLE_SETTING = NS + 'CHANGE_TABLE_SETTING'

export const FIND_ALL_PROSPECT_REQUEST = NS + 'FIND_ALL_PROSPECT_REQUEST'
export const FIND_ALL_PROSPECT_SUCCESS = NS + 'FIND_ALL_PROSPECT_SUCCESS'
export const FIND_ALL_PROSPECT_ERROR = NS + 'FIND_ALL_PROSPECT_ERROR'




// WEBPACK FOOTER //
// ./src/modules/prospect/state/search/type.js